import { Box, Grid, alpha, styled } from '@mui/material';

export const AssetImageContainer = styled(Grid)(() => ({
  height: '10rem',
  textAlign: 'center'
}));

export const OfferDataImage = styled('img')(() => ({
  height: '100%',
  width: '100%',
  objectFit: 'contain'
}));

export const PartnerImageContainer = styled(Grid)(() => ({
  height: '7rem',
  textAlign: 'center'
}));

export const PolicyWarningContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: theme.palette.warning.main,
  flexGrow: 1,
  backgroundColor: alpha(theme.palette.warning.main, 0.1),
  borderRadius: '10px',
  padding: theme.spacing(1)
}));

export const PolicyOfferQuotationsProcessingText = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export const PolicyOfferQuotationsWarningText = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: theme.palette.warning.main
}));
